export default {
  selectedView: localStorage.getItem('selectedView'),
  disableEdit: false,
}
